
const state = {
	stickyGame: localStorage.getItem('stickyGame') || '[]',
  topicDetail: [],
  deleteId: [],
  shareGameId: '',
  gameId: '',
  isSdk: localStorage.getItem('isSdk') || false,
  sdkPageActive: 1
}
const mutations = {
  setSdkPageActive(state,active){
    state.sdkPageActive = active
  },
  setIsSdk(state){
    state.isSdk = true
    localStorage.setItem('isSdk',true)
  },
  setCommunityId(state,id){
    state.gameId = id
  },
  setCommunityData(state,data){
    if(!data) {
      state.shareGameId = ''
      return
    }
    const regex = new RegExp(`[?&]id=([^&#]*)`);
    const results = regex.exec(data);
    state.shareGameId = results[1]
  },
  setTopicDelete(state,id){
    state.deleteId.push(id)
  },
	setStickyGame(state,data){
		state.stickyGame = JSON.stringify(data)
    localStorage.setItem('stickyGame',JSON.stringify(data))
	},
  addTopicDetail(state,data){
    state.topicDetail = data
  }
}
export default {
	state,
	mutations,
}